export default "__VITE_ASSET__DGQzHvy3__"